module.exports = __webpack_public_path__ + "img/tempo-logo-new.858e4f2c.png";